<template>
  <GmapMap
    :center="{lat:51.786265,lng:-2.674002}"
    :zoom="11"
    map-type-id="terrain"
    class="map"
  >

    <GmapMarker
      v-if="playerLocation"
      :position="playerLocation"
      :icon="playerIcon"
    />

    <GmapMarker
      v-for="(wolf) in wolves"
      :position="{lat: wolf.latitude, lng: wolf.longitude}"
      :key="wolf.wolf"
      :icon="locIcon"
    />

    <GmapCluster>
      <PostMarker
        v-for="(post, index) in posts"
        v-if="post.geo"
        :post="post"
        :key="index"
      />
    </GmapCluster>

    <GmapInfoWindow/>
  </GmapMap>
</template>

<script>
import PostMarker from "./PostMarker";
import {
  faMapMarkerAlt,
  faComment,
  faCommentAlt
} from "@fortawesome/free-solid-svg-icons";
import { icon, library } from "@fortawesome/fontawesome-svg-core";
library.add(faMapMarkerAlt);

console.dir("marker", icon(faMapMarkerAlt));

export default {
  name: "Map",
  components: {
    PostMarker
  },
  props: {
    wolves: {
      type: Array,
      required: true
    },
    posts: {
      type: Array,
      required: true
    },
    playerLocation: {
      type: Object,
      default: () => undefined
    }
  },
  data() {
    return {
      playerIcon: require("../assets/playerIcon.svg"),
      locIcon: require("../assets/iconTest.svg")
    };
  }
};
</script>

<style scoped>
.map {
  width: 100%;
  max-width: 1200px;
  margin: auto;
  height: 1080px;
}
</style>



// WEBPACK FOOTER //
// src/components/Map.vue